<template>
  <div>
    <div>
      <!-- Breadcrumbs with home icon and links to travel services page -->
      <ol
        class="breadcrumb container d-none d-md-flex"   
      >
        <li>
          <a href="/" class="has-icon icon-l text-dark">
            <i class="material-icons"></i>
            <span>Home</span>
          </a>
        </li>
        <li>
          <a href="/travel-services" class="text-dark"
            >Travel Services</a
          >
        </li>
        <li>
          <a href="/visas" class="text-dark"
            >Trailfinders Visa Service</a
          >
        </li>
        <li class="active">{{ imageHeader }}</li>
      </ol>
    </div>
    <!-- Load page top background image with title and summary-->
    <div class="app-hero-img">
      <b-img :src="imageUrl" alt="Trailfinders Visa Service"></b-img>

      <div class="d-flex justify-content-center">
        <div class="caption-centered position-absolute top-40 bg-dark bg-opacity-50 p-3 justify-content-center"
             style="border-radius:20px; max-width:550px; z-index:5">
          <div class="flex-column text-center text-light">
            <h1 class="text-light m-4">{{ imageHeader }}</h1>
            <h3 v-if="mobile===false && webpageSummary !=''" class="text-light fs-6" v-html="webpageSummary">
            </h3>
          </div>
        </div>
      </div>
    </div>

    <!-- Country Visa service title -->
    <section class="app-section app-section-grey container-fluid" v-bind:class="smallcss">
      <div class="container">
        <div class="accordion accordion-flush" id="visa-contents">
          <div v-for="(content, index) in showVisaContents" :key="content._id" :index="index">
            <div class="accordion-item accordion-visa">
              <h2 class="accordion-header" v-bind:id="'heading-' + index">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                   v-bind:data-bs-target="'#body-' +index"
                   aria-expanded="false"
                   v-bind:aria-controls="'body-' + index">
                   {{content.section_title}}
                </button>
              </h2>
              <div v-bind:id="'body-' + index" class="accordion-collapse collapse"
                         v-bind:aria-labelledby="'heading-' +index"
                         v-bind:data-bs-parent="'#heading-' + index">
                        <div class="accordion-body content-style" v-html="content.section_details"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

<!--      <div v-if="mobile===true">-->
<!--        <p class="mt-4 mb-4" style="text-align:left; margin-left: 40px">-->
<!--          <span class="text-strong text-success">{{ getCurrency() }}20pp OFF Visa Service Charges</span>-->
<!--          when you book your travel with Trailfinders-->
<!--        </p>-->
<!--      </div>-->
    </section>
  </div>
</template>

<script>
import { getVisaCountry } from "@/services/api.js";

export default {
  data() {
    return {
      meta: {
        loaded: true,
      },
      docdata: {},
      showVisaContents: [],
      webpagetitle: '',
      site: '',
      mobile: window.innerWidth <= 768,
      tablet: window.innerWidth <= 991,
      webpageSummary: "",
      visaCountry: "",
      imageHeader: "",
      imageUrl: "",
      referer: window.siteVar.referer,
     // countries: [],
     // checkboxAgree:false,
     // alertAgree:false,
     // checkboxNobooking:false,
     // alertNobooking:false,
    };
  },
  created() {
    addEventListener("resize", () => {
      this.mobile = innerWidth <= 768;
      this.tablet = innerWidth <= 991;
    });
  },
  mounted() {
    this.meta.loaded = true;
    this.webpagetitle = this.$route.params.webpagetitle;
    this.site = this.$route.params.site;
    this.getVisaCountry();
    window.scrollTo(0,0); //scroll to top of page
  },
  computed: {
    smallcss: function() {
      return ((this.mobile===true) || (this.tablet===true)) ? 'app-section-smaller' : '';
    }
  },
  methods: {
    async getVisaCountry() {
      const visaData = await getVisaCountry(this.site, this.webpagetitle);
      this.docdata = visaData[0];

      //need to work out what goes into the accordion
      var show_contents = [];

      this.docdata.details.forEach(function (item) {
        if((item.display_where === 'both') || (item.display_where === 'web')) {
          show_contents.push(item)
        }
      })

      this.showVisaContents = show_contents
      //now, if the visa document has a PDF attachment, that needs to go in the last
      //this.showVisaContents accordion entry.
      //it needs to be added to the this.showVisaContents[lastone].section_details field
      if(this.docdata.attach_pdf) {
        if(this.docdata.attach_pdf !='') {
          var theLen = this.showVisaContents.length;
          theLen = theLen-1;
          var theexistingcontent = this.showVisaContents[theLen].section_details
          var thecontent = '<p>' + 'To go to the ' + this.docdata.country + ' visa application form, please '
              + '<a href = "' + this.docdata.attach_pdf + '" target="_new">click here</a>' + '</p>'

          if (typeof theexistingcontent !== 'undefined') {
            if(theexistingcontent !='') {
              this.showVisaContents[theLen].section_details = this.showVisaContents[theLen].section_details + thecontent
            } else {
              this.showVisaContents[theLen].section_details = thecontent
            }
          } else {
            this.showVisaContents[theLen].section_details = thecontent
          }
        }
      }

      // if(this.docdata.attach_pdf_2) {
      //   if(this.docdata.attach_pdf_2 !='' && this.docdata.attach_pdf_filename_2 != '') {
      //     var theLen2 = this.showVisaContents.length;
      //     theLen2 = theLen2-1;
      //     var theexistingcontent2 = this.showVisaContents[theLen2].section_details
      //
      //     var theVisaName = this.docdata.attach_pdf_filename_2;
      //     var theIndex = theVisaName.indexOf('.')
      //     theVisaName = theVisaName.substring(0, theIndex)
      //     theVisaName = theVisaName.replace(/_/g," ");
      //
      //
      //     var thecontent2 = '<p>' + 'To go to the ' + theVisaName + ' application form, please '
      //         + '<a href = "' + this.docdata.attach_pdf_2 + '" target="_new">click here</a>' + '</p>'
      //
      //     if (typeof theexistingcontent2 !== 'undefined') {
      //       if(theexistingcontent2 !='') {
      //         this.showVisaContents[theLen2].section_details = this.showVisaContents[theLen2].section_details + thecontent2
      //       } else {
      //         this.showVisaContents[theLen2].section_details = thecontent2
      //       }
      //     } else {
      //       this.showVisaContents[theLen2].section_details = thecontent2
      //     }
      //   }
      // }


      this.imageHeader = this.docdata.country_name;
      this.imageUrl = this.docdata.tf_image;
      this.webpageSummary = this.docdata.webpage_summary;
      this.visaCountry = this.docdata.country;

      this.meta.loaded = true;
    },

    getCurrency() {
      let currency = "£";
      if (this.getRegion()) {
        currency = window.siteVar.referer === "IE" ? "€" : currency;
      }
      return currency;
    },
    getRegion() {
      let region = "UK";
      if (window.siteVar.referer) {
        region = window.siteVar.referer;
      }
      return region;
    },
    // applyVisa(){
    //   this.alertAgree = false
    //   this.alertNobooking = false
    //   if(!this.checkboxAgree){
    //     this.alertAgree = true
    //     return
    //   }
    //   if(!this.checkboxNobooking){
    //     this.alertNobooking = true
    //     return
    //   }
    //   // const cubanVisaUrl = "https://www.trailfinders.com/visas/cuba#/cuban-visa-application"
    //   // window.location.href = cubanVisaUrl;
    // },
    getVisaProcessDetailsWidth() {
      return this.mobile ? "max-width: 30rem; margin:0 auto" : "max-width: 50rem;  margin:0 auto";
    }
  },
};
</script>
<style>
.content-style strong { font-weight: bold !important }
.app-section-smaller {
    padding-top: 30px !important;
    padding-bottom: 30px !important;
}
</style>